import { CommunityWins } from '@platform/client';
import { Input, Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

interface CreateCommunityWinModalProps {
  isOpen: boolean;
  onClose: () => void;
  resetPagination: () => void;
  limit: number;
}

export const CreateCommunityWinModal = (props: CreateCommunityWinModalProps) => {
  const { isOpen, onClose, resetPagination, limit } = props;

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [link, setLink] = useState('');

  const queryClient = useQueryClient();

  const submitCommunityWin = CommunityWins.useCreateCommunityWin({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...CommunityWins.getGetCommunityWinsQueryKey({ page: 0, limit })],
        });
        resetPagination();
      },
    },
  });

  const createCommunityWin = async () => {
    submitCommunityWin.mutate({
      data: {
        title,
        description,
        link,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
    setTitle('');
    setDescription('');
    setLink('');
  };

  return (
    <Modal
      variant='dialog'
      title='Create Community Win'
      isOpen={isOpen}
      headerDivision='divider'
      onClose={closeModal}
      ignoreExtraPadding={true}
      primaryCTA={{
        text: 'Create Community Win',
        callback: createCommunityWin,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          <Input
            label='Title'
            type='inline'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <Input
            label='Description'
            type='multiline'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Input
            label='Link'
            type='inline'
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
};
